import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=4b0f5e80&lang=html&"
import script from "./Inbox.vue?vue&type=script&lang=js&"
export * from "./Inbox.vue?vue&type=script&lang=js&"
import style0 from "./Inbox.vue?vue&type=style&index=0&id=4b0f5e80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports